import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormIconSelect from "Common/Custom/FormIconSelect";

// Uses `fields` prop from parent — does not re-import JSON directly
const AddRoomFacilityDetailForm = ({
  fields = [],
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  imagePreview,
  facilityTypeOptions = [],
  title = "Create Room Facility Detail",
}) => {
  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>{title}</HeadingOne>}
    >
      {fields.map((field) => {
        if (field.type === "select") {
          const options = facilityTypeOptions.map((opt) => ({
            value: opt.facilitytypeid,
            label: opt.facilitytypetitle,
          }));
          return (
            <FormSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              options={options}
              error={errors[field.name]}
            />
          );
        }
        if (field.type === "iconselect") {
          return (
            <FormIconSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }

        if (field.type === "file") {
          return (
            <FormInputFile
              key={field.name}
              field={field}
              handleChange={handleFileChange}
              error={errors[field.name]}
              imagePreview={imagePreview}
            />
          );
        }

        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default AddRoomFacilityDetailForm;
